<template>
  <div>
    <mt-header fixed title="修改密码">
      <router-link to="/index/profile" slot="left">
        <mt-button icon="back">返回</mt-button>
      </router-link>
    </mt-header>
    <div class="login-form">
      <input type="password" placeholder="请输入原密码" v-model="prePwd">
      <input type="password" placeholder="请输入新密码" v-model="newPwd">
      <input type="password" placeholder="请再输入新密码" v-model="repeatPwd">
    </div>
    <div class="login-btn">
      <button type="button" class="login-btn-login" @click="doSubmit">确定</button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueResource from 'vue-resource'
import { Toast } from "mint-ui";
Vue.use(VueResource)
export default {
  name: "Login",
  data: function(){
    return {
      prePwd: "",
      newPwd: "",
      repeatPwd: ""
    }
  },
  computed: {
    empty(){
      return this.prePwd == "" || this.newPwd == "" || this.repeatPwd == "";
    },
    validate() {
      return this.newPwd == this.repeatPwd;
    }
  },
  methods: {
    doSubmit: function() {
      if(this.empty){
        Toast("请输入账号和密码!");
        return;
      }
      if (!this.validate) {
        Toast("两次新密码输入不一致!");
        return;
      }
      this.$http
        .post(this.GLOBAL.serverUrl + "/user/pwd/modify", {
          prePwd: this.prePwd,
          newPwd: this.newPwd
        }, { emulateJSON: true })
        .then(
          function(resp) {
            var resObj = resp.body;
            if (resObj.code == 200) {
              Toast("密码修改成功!");
              this.$router.push("/index/profile");
            } else if (resObj.code == 500 && resObj.msg) {
              Toast(resObj.msg);
            }
          }
        );
    }
  }
};
</script>

<style scoped>
.login-form {
  text-align: center;
  padding: 0 1rem;
  margin-top: 5rem;
}

.login-form input {
  width: 100%;
  height: 3rem;
  margin-top: 2rem;
  border: none;
  border-bottom: 1px solid #dddddd;
  font-size: 1rem;
  padding-left: 1rem;
  box-sizing: border-box;
}

.login-btn {
  padding: 0 1rem;
  margin-top: 3rem;
  text-align: center;
}

.login-btn .login-btn-login {
  background: #006dbc;
  border-radius: 2rem;
  width: 100%;
  height: 2.5rem;
  border: none;
  color: white;
  font-size: 1rem;
}

.more-btn {
  margin-top: 1rem;
  text-align: center;
}

.more-btn a {
  text-decoration: none;
  height: 1.5rem;
  line-height: 1.5rem;
  display: inline-block;
  margin: 0 0.5rem;
}
</style>